import React from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';

function SummaryCard({ label, value, bgcolor = '#fafafa' }) {
  return (
    <Paper sx={{ p: 2, textAlign: 'center', bgcolor, height: '100%' }}>
      <Typography variant="h5" fontWeight={700}>
        {value}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
    </Paper>
  );
}

function StreakSummaryCards({ report }) {
  if (!report) return null;

  const { currentState, summary } = report;
  const noStreak = !currentState;

  return (
    <>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 2 }}>
        <Box sx={{ flex: '1 1 140px', minWidth: 140 }}>
          <SummaryCard
            label="Current streak"
            value={noStreak ? 'No record' : currentState.currentStreak}
            bgcolor="#e8f5e9"
          />
        </Box>
        <Box sx={{ flex: '1 1 140px', minWidth: 140 }}>
          <SummaryCard
            label="Longest streak"
            value={noStreak ? '—' : currentState.longestStreak}
            bgcolor="#e3f2fd"
          />
        </Box>
        <Box sx={{ flex: '1 1 140px', minWidth: 140 }}>
          <SummaryCard
            label="Last broken streak"
            value={noStreak ? '—' : currentState.lastStreak}
            bgcolor="#fff3e0"
          />
        </Box>
        <Box sx={{ flex: '1 1 140px', minWidth: 140 }}>
          <SummaryCard
            label="Last active date"
            value={noStreak ? '—' : (currentState.lastActiveDate || '—')}
            bgcolor="#f3e5f5"
          />
        </Box>
        <Box sx={{ flex: '1 1 140px', minWidth: 140 }}>
          <SummaryCard
            label="Days with issues"
            value={summary?.daysWithIssues ?? 0}
            bgcolor={summary?.daysWithIssues > 0 ? '#ffebee' : '#fafafa'}
          />
        </Box>
      </Box>

      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={4}>
          <SummaryCard
            label="Days with daily activity"
            value={summary?.daysWithDailyActivity ?? 0}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <SummaryCard
            label="Days with APP_VISIT"
            value={summary?.daysWithAppVisit ?? 0}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <SummaryCard
            label="Days streak counted"
            value={summary?.daysWithStreakCounted ?? 0}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default StreakSummaryCards;
